<template>
  <div class="coupon-detail">
    <div class="content">
      <div class="card">
        <div class="top">
          <img class="logo" :src="detail.icon" v-if="detail.icon" />
          <div class="main">
            <div class="name">{{ detail.name || '代金券' }}</div>
            <div class="cond">{{ detail.condition || '—' }}</div>
          </div>
          <div class="price">
            <div class="amount"><span class="currency">¥</span>{{ detail.amount }}</div>
            <div v-if="statusText" class="tag" :class="statusClass">{{ statusText }}</div>
          </div>
        </div>
      </div>

      <div class="desc">
        <div class="desc-title">使用说明</div>
        <div class="desc-content" v-if="detail.description" v-html="detail.description"></div>
        <div class="desc-content muted" v-else>暂无说明</div>
      </div>

      <div class="action">
        <van-button
          block
          round
          type="primary"
          :loading="loading"
          :disabled="loading || statusText === '已核销' || statusText === '已过期' || statusText === '已领取'"
          @click="claim"
        >
          {{ actionText }}
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getCouponDetail, claimCoupon } from '@/api/coupon'
import { Toast } from 'vant'
export default {
  name: 'couponDetail',
  data() {
    return {
      id: this.$route.params.id,
      loading: false,
      detail: {
        id: '',
        icon: '',
        name: '',
        amount: 0,
        condition: '',
        description: ''
      }
    }
  },
  async mounted() {
    await this.load()
  },
  computed: {
    statusText() {
      const s = this.$route.query.status
      if (s === 'REDEEMED') return '已核销'
      if (s === 'EXPIRED') return '已过期'
      if (s === 'RECEIVED') return '已领取'
      return ''
    },
    statusClass() {
      const s = this.$route.query.status
      if (s === 'REDEEMED') return 'redeemed'
      if (s === 'EXPIRED') return 'expired'
      return 'received'
    },
    actionText() {
      if (this.loading) return '领取中'
      if (this.statusText) return this.statusText
      return '领取'
    }
  },
  methods: {
    async load() {
      // 优先使用路由 query（来自列表/已领取跳转），后端 detail 暂未实现
      this.detail = {
        ...this.detail,
        id: this.id,
        name: this.$route.query.name || this.detail.name,
        amount: this.$route.query.amount || this.detail.amount,
        condition: this.$route.query.condition || this.detail.condition,
        icon: this.$route.query.icon || this.detail.icon,
        description: this.$route.query.description || this.detail.description,
      }
      try {
        const { data } = await getCouponDetail({ id: this.id })
        this.detail = { ...this.detail, ...(data || {}) }
      } catch (e) {
        // ignore
      }
    },
    async claim() {
      this.loading = true
      try {
        const { data } = await claimCoupon({ couponId: this.id })
        if (data) {
          Toast.success('领取成功')
          this.$router.replace({ name: 'couponClaimed' })
        } else {
          Toast.fail('领取失败')
        }
      } catch (e) {
        Toast.fail('领取失败，请稍后重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped lang="less">
.coupon-detail {
  min-height: 100vh;
  background: #f7f7f8;
  box-sizing: border-box;
}
.content {
  padding: 0.6rem 0.6rem 1rem;
  padding-bottom: calc(1rem + constant(safe-area-inset-bottom));
  padding-bottom: calc(1rem + env(safe-area-inset-bottom));
}
.card {
  background: #fff;
  border-radius: 0.5rem;
  padding: 0.6rem;
  box-shadow: 0 0.12rem 0.24rem rgba(0,0,0,0.06);
  border: 1px solid rgba(0,0,0,0.04);
}
.top {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}
.logo {
  width: 1.34rem;
  height: 1.34rem;
  border-radius: 0.28rem;
  background: #f4b6ac;
  flex-shrink: 0;
}
.main {
  min-width: 0;
  flex: 1;
}
.name {
  font-size: 0.48rem;
  color: #333;
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.amount {
  font-size: 0.52rem;
  color: #9b1b1b;
  font-weight: 900;
  line-height: 1;
}
.currency {
  font-size: 0.32rem;
  margin-right: 0.06rem;
  font-weight: 700;
}
.cond {
  margin-top: 0.08rem;
  font-size: 0.34rem;
  color: #8a8a8a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.price {
  text-align: right;
  flex-shrink: 0;
}
.tag {
  display: inline-block;
  margin-top: 0.16rem;
  font-size: 0.3rem;
  padding: 0.08rem 0.22rem;
  border-radius: 0.24rem;
}
.tag.received { background: #e8f3ff; color: #3a7afe; }
.tag.expired { background: #fff1f0; color: #db3e2f; }
.tag.redeemed { background: #f0fff4; color: #22c55e; }
.desc {
  margin-top: 0.7rem;
  background: #fff;
  border-radius: 0.5rem;
  padding: 0.6rem;
  box-shadow: 0 0.12rem 0.24rem rgba(0,0,0,0.06);
  border: 1px solid rgba(0,0,0,0.04);
}
.desc-title {
  font-size: 0.42rem;
  color: #333;
  margin-bottom: 0.22rem;
  font-weight: 700;
}
.desc-content {
  font-size: 0.34rem;
  color: #666;
  line-height: 1.68;
  white-space: pre-line;
}
.muted {
  color: #9a9a9a;
}
.action {
  margin-top: 1rem;
}
.van-button--primary {
  background: #9b1b1b;
  border: none;
}
</style>
